<mat-grid-list cols='8' rowHeight="100%">
    <mat-grid-tile-header>
        <tl-header></tl-header>
    </mat-grid-tile-header>
    <mat-grid-tile colspan='8'>
        <div class="tl-container">
            <ng-content></ng-content>
        </div>
    </mat-grid-tile>
</mat-grid-list>